<template>
  <vue-scroll class="page-dashboard">
    <div
      class="page-header header-accent-gradient card-base card-shadow--small"
    >
      <h1>Examples</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Apps</el-breadcrumb-item>
        <el-breadcrumb-item>Examples</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <rabbey-toolbox :filterables="true" @filter-search="search = $event">
      <div class="box mr-5">
        <el-select
          v-model="value"
          placeholder="Select"
          size="mini"
          clearable
          filterable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </rabbey-toolbox>

    <!-- <el-row>
      <el-col>
        <rabbey-table
          ref="r"
          :headers="headers"
          :actions="actions"
          index-url="/api/serviceRequests"
          @get:data="getData"
          @rtable-push-action="onPushAction"
        />
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <rabbey-tables-tabs
          ref="s"
          :tabs="tabs"
          index-url="/api/serviceRequests"
          :get-data="getData2"
          @table:push-action="onPushAction"
        />
      </el-col>
    </el-row> -->

    <el-row>
      <el-col>
        <rabbey-table2
          index-url="/api/users"
          :search="search"
          key-search="FullName"
          :columns="columns2"
          :actions="actions2"
          :defaultParams="defaultParams"
          :paginateFromApi="false"
          @rtable-push-action="onPushAction"
        />
      </el-col>
    </el-row>

    <DetailExample ref="detail" />
  </vue-scroll>
</template>

<script>
import DatetimeFormatter from "../components/functionals/DatetimeFormatter.vue";
import ImagePerson from "../components/functionals/ImagePerson.vue";
import DetailExample from "./DetailExample.vue";

const HEADERS = [
  {
    prop: "Id",
    name: "NO",
    width: 80,
    sortable: true
  },
  {
    prop: "ServiceRequestType.Description",

    name: "Solictud",
    sortable: true,
    formatter: (row) => {
      return row.ServiceRequestType.Description;
    }
  },
  {
    prop: "RequestDate",
    name: "Creado",
    formatter: DatetimeFormatter
  },
  {
    prop: "Customer.CustomerService",
    name: "Servicio",
    formatter: ImagePerson
  }
];

const ACTIONS = [
  {
    icon: "el-icon-view",
    label: "View",
    command: "view"
  }
];

export default {
  name: "Dashboard",
  components: { DetailExample },
  data() {
    return {
      options: [
        {
          value: "Option1",
          label: "Option1"
        },
        {
          value: "Option2",
          label: "Option2"
        },
        {
          value: "Option3",
          label: "Option3"
        },
        {
          value: "Option4",
          label: "Option4"
        },
        {
          value: "Option5",
          label: "Option5"
        }
      ],
      value: "",
      search: "",
      columns2: [
        {
          prop: "Id",
          name: "ID",
          sortable: true
        },
        {
          prop: "UserName",
          name: "User Name",
          sortable: true
        },
        {
          prop: "FullName",
          name: "Nombre",
          sortable: true
        },
        {
          prop: "Email",
          name: "Email"
        }
      ],
      actions2: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        }
      ],
      loading: false,
      headers: HEADERS,
      actions: ACTIONS,
      tabs: [
        { label: "Tab 1", name: "New", headers: HEADERS, actions: ACTIONS },
        { label: "Tab 1", name: "Assigned", headers: HEADERS, actions: ACTIONS }
      ]
    };
  },
  mounted() {
    this.getData();
    this.getData2();
  },
  computed: {
    // Set Default Company
    defaultParams() {
      return {
        status: 0,
        companyCode: this.currentCompany
      };
    }
  },
  methods: {
    onPushAction(options) {
      // options.command;
      // options.row;
      // options.index;
      // options.column;
      if (options.command === "view") {
        this.$refs.detail.show(options.row);
      }
    },
    getData() {
      const table = this.$refs.r;
      const config = {
        params: {
          "criteria.DepartmentId": 2,
          "criteria.Page": table.pagination.currentPage,
          "criteria.Limit": table.pagination.pageSize,
          "criteria.ProductId": 0,
          "criteria.ServiceRequestTypeId": 0,
          "criteria.Status": "New",
          "criteria.TechnicianId": 0,
          "criteria.companyCode": this.$store.state.user.user.CompanySelected
        }
      };
      table.indexConfig = config;
      table.getData();
    },
    getData2() {
      const tab = this.$refs.s;
      const table = tab.rabbeyTable();
      const config = {
        params: {
          "criteria.DepartmentId": 2,
          "criteria.Page": table.pagination.currentPage,
          "criteria.Limit": table.pagination.pageSize,
          "criteria.ProductId": 0,
          "criteria.ServiceRequestTypeId": 0,
          "criteria.Status": tab.activeTab,
          "criteria.TechnicianId": 0,
          "criteria.companyCode": this.$store.state.user.user.CompanySelected
        }
      };
      table.indexConfig = config;
      table.getData();
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
